export enum CsvStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    WARNING = "WARNING",
    VALIDATED = "VALIDATED",
    PROCESSED = "PROCESSED",
    UPLOAD_FINISHED = "UPLOAD FINISHED"
}

export interface CsvImportResponseEntity {
  statusDescription: string
  csvStatus: CsvStatus
}

export interface CsvImportResponse<E> {
  filename: string
  csvStatus: CsvStatus
  statusDescription: string
  items: any
}
